export default __webpack_public_path__ + "static/media/mars10.97bbed76.gif";